import type { FaireProductEntity } from "../../entity_types/product";

export const p_sw2pcdeq2a: FaireProductEntity = {
  token: "p_sw2pcdeq2a",
  type: "product",
  name: "Chinoiserie Floral Pattern Scalloped Stationery Card Set",
  brandToken: "b_d3cpxt2ubz",
  brandName: "Design Carolinas",
  imageUrl:
    "https://cdn.faire.com/fastly/89471de0a0faa1162397b5b5260770ffe273e8ffa5848bbf12dc2c5b548acee9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c545441b6af94ade12fe28e2a37af921d1d55500e6647223f1d799d456bcffc3.png",
    "https://cdn.faire.com/fastly/66de58adac10ab77efa7b425b4ee046aeb923db96492da35336e82a5d520ab9a.png",
    "https://cdn.faire.com/fastly/9c90c6807a34ce076309d3428c80c3685e39129a84f4831b81d36db27d9fb114.png",
    "https://cdn.faire.com/fastly/6eadaa7a61f8aaf0ae707d20e516bc84115b91e983daabbb11daf0cb537bf747.png",
    "https://cdn.faire.com/fastly/77d4d378c076b03c684709124ff3953bbd66077b0b13b386d48525168a598051.png",
    "https://cdn.faire.com/fastly/61631244bf38ddd514c0b97bad8f4129e4ac05e250960ac498e0d0f2a94dbc01.jpeg",
  ],
  priceDollars: 10,
  description:
    "Send a note or thank you card, on this cute card featuring a gorgeous pink and green floral pattern and a scalloped wave border. \n\nLoved by those with an affinity for chinoiserie patterns, grandmillenial vibes and flowers in general. A best seller for many shops!\n\nCards measure  4.25\" x 6.25 and include white envelopes - each envelope has a liner with the matching pattern that is on the back of the card. \n\nChoose from one of our premade headings, or write your own\n\nPrinted on high quality matte paper\n*17.5 pt thickness / 120 lb weight / 324 GSM\n* Light white, uncoated matte finish with an eggshell texture\n* Paper is easy to write on and won't smudge\n\nPackaged to show off both the envelope liner and the design on both sides of the card. ",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:06.030Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
